import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {ServiceRequirementGroup} from './service-requirement-group.model';
import * as ServiceRequirementGroupActions from './service-requirement-group.actions';

export const serviceRequirementGroupsFeatureKey = 'serviceRequirementGroups';

export interface State extends EntityState<ServiceRequirementGroup> {
  // additional entities state properties
}

export const adapter: EntityAdapter<ServiceRequirementGroup> = createEntityAdapter<ServiceRequirementGroup>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(ServiceRequirementGroupActions.addServiceRequirementGroup,
    (state, action) => adapter.addOne(action.serviceRequirementGroup, state)
  ),
  on(ServiceRequirementGroupActions.upsertServiceRequirementGroup,
    (state, action) => adapter.upsertOne(action.serviceRequirementGroup, state)
  ),
  on(ServiceRequirementGroupActions.addServiceRequirementGroups,
    (state, action) => adapter.addMany(action.serviceRequirementGroups, state)
  ),
  on(ServiceRequirementGroupActions.upsertServiceRequirementGroups,
    (state, action) => adapter.upsertMany(action.serviceRequirementGroups, state)
  ),
  on(ServiceRequirementGroupActions.updateServiceRequirementGroup,
    (state, action) => adapter.updateOne(action.serviceRequirementGroup, state)
  ),
  on(ServiceRequirementGroupActions.updateServiceRequirementGroups,
    (state, action) => adapter.updateMany(action.serviceRequirementGroups, state)
  ),
  on(ServiceRequirementGroupActions.deleteServiceRequirementGroup,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(ServiceRequirementGroupActions.deleteServiceRequirementGroups,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(ServiceRequirementGroupActions.loadServiceRequirementGroups,
    (state, action) => adapter.setAll(action.serviceRequirementGroups, state)
  ),
  on(ServiceRequirementGroupActions.clearServiceRequirementGroups,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
